module.exports = __webpack_public_path__ + "static/pinkvelourballet-f65e710b3528dc595dc6c73ade0d514b.jpeg";